import React from 'react';
import { Scale } from 'lucide-react';

const STAGE_LABELS = {
  preliminary: 'Preliminary stage',
  application_development: 'Application development',
  post_implementation: 'Post-implementation',
  cca_implementation: 'CCA implementation',
  asc360_asset: 'ASC 360 asset',
  always_expense: 'Always expense',
  unknown: 'Unresolved'
};

const CLASS_TONES = {
  capitalize: 'gold',
  expense: 'neutral',
  exclude: 'red',
  unknown: 'yellow'
};

/**
 * D3 classification badge: renders the accounting citation, stage, and confidence
 * for an AI-classified spend line. Read-only; the reviewer edits via the override
 * modal, never here.
 */
const CorporateProjectPolicyBadge = ({ citation, stage, confidence, classification }) => {
  if (!citation && !stage && confidence === undefined) return null;
  const pct = confidence === null || confidence === undefined || Number.isNaN(Number(confidence))
    ? null
    : `${Math.round(Number(confidence) * (Number(confidence) <= 1 ? 100 : 1))}%`;
  return (
    <div className="project-policy-badge" aria-label="Accounting policy classification">
      <span className={`forecast-health-chip ${CLASS_TONES[classification] || 'neutral'} mini`}>
        <Scale size={12} aria-hidden="true" /> {classification || 'unknown'}
      </span>
      {stage ? <span className="forecast-health-chip neutral mini">{STAGE_LABELS[stage] || stage}</span> : null}
      {citation ? <code className="forecast-mono project-policy-citation" title={citation}>{citation}</code> : null}
      {pct ? <span className="forecast-submit-note project-policy-confidence">{pct} confidence</span> : null}
    </div>
  );
};

export default CorporateProjectPolicyBadge;
